/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import ContentfulButtonV3 from '../Utilities/Buttons/V3/ContentfulButtonV3'
import { blogPostOptions } from '../Utilities/DocumentToReactOptions'

/* eslint-disable react/no-danger */
function InfoCard({ data }) {
  const {
    theme,
    rolloverImages,
    contentAlign,
    description,
    finePrintText,
    headline,
    image,
    imageMobile,
    imageButtons,
    text,
    blogPost,
    blogLayout,
    textTable
  } = data
  const imgClasses = [
    blogLayout === 'Blog Category'
      ? 'blog-image'
      : `support-card__img-box ${!imageMobile ? 'image-mobile' : ''}`
  ]

  let imageMobileComp
  if (imageMobile) {
    if (getImage(imageMobile.image)) {
      imageMobileComp = (
        <GatsbyImage
          image={getImage(imageMobile.image)}
          alt={imageMobile?.altText}
          objectFit="scale-down"
        />
      )
    } else {
      imageMobileComp = <img src={imageMobile.image?.file?.url} alt={imageMobile?.altText} />
    }
    imageMobileComp = <div className="support-card__mobile-img-box">{imageMobileComp}</div>
  }

  let imageComp
  if (image) {
    if (getImage(image.image)) {
      imageComp = (
        <GatsbyImage image={getImage(image.image)} alt={image.altText} objectFit="scale-down" />
      )
    } else {
      imageComp = <img src={image.image?.file.url} alt={image.altText} />
    }
    imageComp = <div className={imgClasses.join(' ')}>{imageComp}</div>
  } else if (blogPost && blogPost.featuredImage) {
    imageComp = (
      <GatsbyImage
        image={getImage(blogPost.featuredImage.image)}
        className="blog-image"
        objectFit="scale-down"
      />
    )
  }

  const alignClass = contentAlign ? 'left' : 'right'

  let extraStuff = null
  if (finePrintText || imageButtons) {
    let fineTextComp = null
    if (finePrintText) {
      fineTextComp = (
        <p
          className="support-card__mobile-text"
          dangerouslySetInnerHTML={{ __html: finePrintText }}
        />
      )
    }

    let buttonsComp = null
    if (imageButtons) {
      buttonsComp = (
        <div className="support-card__mobile-button-box">
          {imageButtons.map((button, index) => {
            const key = index + 1
            const { __typename } = button
            if (__typename === 'ContentfulClickableImage') {
              const img = (
                <GatsbyImage
                  key={key}
                  className="support-card__mobile-app"
                  image={getImage(button.image)}
                  alt={button?.imageAltText}
                  objectFit="scale-down"
                />
              )
              if (button.openNewWindow) {
                return (
                  <a
                    className="support-card__mobile-button"
                    href={button.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-event={button.dataEvent}
                    key={key}
                  >
                    {img}
                  </a>
                )
              }
              return (
                <Link
                  className="support-card__mobile-button"
                  to={button.url}
                  rel="noopener noreferrer"
                  data-event={button.dataEvent}
                  key={key}
                >
                  {img}
                </Link>
              )
            }
            return (
              <ContentfulButtonV3 parentComponent="ContentfulInfoCard" data={button} key={key} />
            )
          })}
        </div>
      )
    }

    extraStuff = (
      <div className="support-card__mobile-app-box">
        {buttonsComp}
        {fineTextComp}
      </div>
    )
  }

  let rolloverImagesComp = null
  if (rolloverImages?.length) {
    /* eslint-disable react/no-array-index-key */
    rolloverImagesComp = (
      <div className="rollovers">
        {(rolloverImages || []).map((rollover, index) => {
          const rollImgClasses = [`rollover`, `index_${index}`]
          if (index === 0) rollImgClasses.push('active')
          return (
            <GatsbyImage
              className={rollImgClasses.join(' ')}
              image={getImage(rollover.image)}
              alt={rollover.altText}
              key={index}
            />
          )
        })}
      </div>
    )
  }

  const subtextComp = text ? <div className="support-card__subtext">{text.text}</div> : null

  const contentBoxClasses = [`support-card__text-content-box`]
  const descriptions = []

  const mouseOverFunc = e => {
    const el = e.target
    const imgParent = document.querySelector('div.rollovers')
    const pParent = el.parentNode
    if (!imgParent) return
    const activeImg = imgParent.querySelector('.active')
    const activeP = pParent.querySelector('.active')
    if (activeImg) activeImg.classList.remove('active')
    if (activeP) activeP.classList.remove('active')
    const hoverIndex = Array.from(el.parentNode.children).indexOf(el)
    imgParent.children[hoverIndex].classList.add('active')
    el.classList.add('active')
  }

  if (description && description.length) {
    let mouseOverEvent = null
    if (description.length > 1 && description.length === rolloverImages?.length) {
      contentBoxClasses.push('rollover')
      mouseOverEvent = mouseOverFunc
    }
    description.forEach((p, index) => {
      let paragraph = p
      const pClasses = [
        `support-card__text`,
        `heading-section-sub`,
        `index_${index}`,
        blogLayout === 'Blog Category' ? `blog-post--category-description` : ''
      ]
      if (index === 0) pClasses.push('active')
      if (paragraph.includes('|')) {
        const firstIndexBlueText = paragraph.indexOf('|')
        const lastIndexBlueText = paragraph.lastIndexOf('|')
        const blueText = paragraph.slice(firstIndexBlueText + 1, lastIndexBlueText)
        paragraph = `${paragraph.slice(
          0,
          firstIndexBlueText
        )}<span class="blue-text">${blueText}</span>${paragraph.slice(lastIndexBlueText + 1)}`
      }
      descriptions.push(
        <p
          onMouseOver={mouseOverEvent}
          onFocus={mouseOverEvent}
          className={pClasses.join(' ')}
          dangerouslySetInnerHTML={{ __html: paragraph }}
          key={JSON.stringify(p)}
        />
      )
    })
  }

  if (descriptions.length > 1) contentBoxClasses.push('list-style')
  if (textTable) contentBoxClasses.push('text-table')
  const sectionClasses = ['costumer-support']
  const h2Classes = [
    'heading-section--support',
    'heading-sub-bold',
    blogLayout === 'Blog Category' ? `blog-post--category` : ''
  ]
  if (blogPost) {
    sectionClasses.push('blog-mb')
  }
  if (!descriptions?.length) {
    sectionClasses.push('no-description')
  }

  if (theme && theme !== 'Default (White)') {
    sectionClasses.push(`theme-${theme.toLowerCase().replaceAll(' ', '-')}`)
  }

  let blogPostComp
  if (blogPost) {
    let tags
    if (blogPost.tags !== null) {
      tags = blogPost.tags?.map(tag => (
        <span className="blog-post--tag" key={tag}>
          {` | ${tag}`}
        </span>
      ))
    }

    const linkReadMore = (
      <span>
        <a className="read-more" href={`${process.env.GATSBY_BASE_URL}${blogPost.slug}`}>
          READ MORE
        </a>
      </span>
    )

    let blogText
    if (blogPost.postBody) {
      const options = blogPostOptions(linkReadMore)
      const result = renderRichText(blogPost.postBody, options)
      // eslint-disable-next-line prefer-destructuring
      blogText = result?.[0]
    }

    blogPostComp = (
      <div className="support-card__blog">
        <p className="blog-post--category">{blogPost.tags === null ? blogPost.categories : tags}</p>
        <h1 className="blog-post--title">{blogPost.postTitle}</h1>
        <p className="blog-post--byline">{blogPost.author}</p>
        <p className="blog-post--date">{blogPost.publishDate}</p>
        {blogText}
      </div>
    )
  }

  return (
    <section className={sectionClasses.join(' ')}>
      <div className="support-card">
        <div className={`container__inner ${alignClass}`}>
          {imageComp}
          <div
            className={blogPost ? 'support-card__content-box-blog' : 'support-card__content-box'}
          >
            <div className="support-card__heading-box">
              <h2 className={h2Classes.join(' ')} dangerouslySetInnerHTML={{ __html: headline }} />
            </div>
            {imageMobileComp}
            {blogPostComp}
            {rolloverImagesComp}
            {subtextComp}
            <div className={contentBoxClasses.join(' ')}>{descriptions}</div>
            {extraStuff}
          </div>
        </div>
      </div>
    </section>
  )
}

InfoCard.propTypes = {
  data: PropTypes.object.isRequired
}

export default InfoCard
